<ngx-doc-viewer [url]="data?.fileUrl" viewer="google" style="width:100%;height:100vh;"></ngx-doc-viewer>